<div class="header">
  <div class="container">
    <a href="javascript:void(0);" class="logo"><img src="../assets/img/vivotek-logo-w.svg" alt="" /></a>
    <h1 class="title">Generate File</h1>
  </div>
</div>
<div class="container-wrap">
  <div class="container">
    <div class="alert alert-warning alert-dismissible fade" [ngClass]="{ show: hasError }" role="alert">
      {{ errorMessage }}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
